/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBatchView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M17 2H2v15h3v-2H4V4h11v1h2V2z" fill="currentcolor" />
      <path d="M22 7H7v15h3v-2H9V9h11v4h2V7z" fill="currentcolor" />
      <path d="M17.868 18a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z" fill="currentcolor" />
      <path
        d="M16.618 14c2.153 0 4.236 1.236 5.395 3.553l.223.447-.224.447C20.854 20.764 18.773 22 16.618 22c-2.153 0-4.236-1.236-5.394-3.553L11 18l.224-.447C12.382 15.236 14.464 14 16.618 14zm-3.355 4c.855 1.372 2.134 2 3.355 2s2.5-.628 3.356-2c-.856-1.372-2.135-2-3.356-2s-2.5.628-3.355 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBatchView as BatchView };
